import { clienteAxiosOctagon, clienteAxiosSaaS } from "../axios";


export const sendMailTo = (dataMail) => {
    try {
        const respuesta = clienteAxiosOctagon({
            method: 'post',
            url: '/octagon/correos/',
            headers: {
                'Authorization': process.env.REACT_APP_OCTAGON_AUTH_TOKEN,
                'bypass': true
            },
            data: dataMail
        })

        return respuesta;
    } catch (error) {
        //Si existe un error
        console.log(error);
        return "Error en envío de correo";
    }
}

export const sendMailWithSaas = (dataMail) => {
    try {
        const respuesta = clienteAxiosSaaS({
            method: "post",
            url: "mail/raw",
            data: dataMail,
        });
        return respuesta;
    } catch (error) {
        //Si existe un error
        console.log(error);
        return "Error en petición a API Correo";
    }
};